import React, {Component} from 'react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {connect} from 'react-redux';
import {Card, Header} from 'semantic-ui-react';
import {CLEAR_ALL_MSG} from 'common/types';
import {Link} from 'react-router-dom';
import REST from 'go/requests/rest';
import {EXCLUDED_ROLES} from 'app-ui-componentlibrary/dist/common/constants';
import {filterExcludedRolesFromPermissions} from 'common/utils';
export class MyOpenTasks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const fetchBody = {
      candidateGroups: filterExcludedRolesFromPermissions(
        this.props.permissions,
        EXCLUDED_ROLES
      ),
      assigned: true,
      assignee: this.props.userId,
      includeAssignedTasks: true,
      processVariables: [],
      sorting: [],
    };
    REST.workflow
      .getTaskCount(this.props.token, fetchBody)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        if (resJson) {
          this.setState(resJson);
          return resJson;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    let {userId} = this.props;

    return (
      <Card>
        <Card.Content>
          <Header as="h3">My open tasks</Header>
          <Card.Meta>{this.state.count} tasks</Card.Meta>
          <Card.Description>
            <Link
              to={'/tasks/list?assignee=' + userId}
              title={'My open tasks'}
              id="content"
              target="_self"
            >
              View >
            </Link>
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
}
export const mapStateToProps = (state) => {
  return {
    userId: state.auth.userId,
    token: state.auth.token,
    permissions: state.auth.permissions,
    messages: state.messages.messages,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    clearAllMsg: () => {
      dispatch({type: CLEAR_ALL_MSG});
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MyOpenTasks);
